// filePages.js
// Pages of files for a section of a file list (the profile dashboard's Needs
// Attention, Processing, ...). A page holds FILES_PER_PAGE files, newest upload
// first: a card is one file, whatever its number of tables. A page starts where
// the previous one ended in upload order (a cursor), not at a count, so a file
// moving between sections never makes Next skip or repeat a file.

import { toMillis } from './timestamps';

export const FILES_PER_PAGE = 24;

// Where a file sits in upload order: newest first, the id breaking ties so the order is
// total. A page cursor is the key of the last file of the previous page.
export const uploadKey = (file) => ({ millis: toMillis(file.created_at), id: file.id });

export function compareUploadKeys(a, b) {
  if (a.millis !== b.millis) return b.millis - a.millis;   // newer first
  if (a.id < b.id) return -1;
  if (a.id > b.id) return 1;
  return 0;
}

export const sortNewestFirst = (files) =>
  [...files].sort((a, b) => compareUploadKeys(uploadKey(a), uploadKey(b)));

// The page of `files` (sorted newest first) that starts after `cursor` (null: the first
// page): the next `limit` files.
export function pageAfter(files, cursor, limit = FILES_PER_PAGE) {
  const start = cursor === null
    ? 0
    : files.findIndex((file) => compareUploadKeys(uploadKey(file), cursor) > 0);
  if (start === -1) return { files: [], hasNext: false };
  return { files: files.slice(start, start + limit), hasNext: start + limit < files.length };
}
